import * as React from 'react';
import { cn } from '@packages/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input ref={ref} type={type} className={cn('ww-input', className)} {...props} />
  ),
);
Input.displayName = 'Input';
